import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ScPersonService } from 'src/app/core/services/sc-person/sc-person.service';
import { DropDown } from 'src/app/shared/model/base-model';

@Component({
  selector: 'sf-sc-person-gender-dropdown',
  templateUrl: './sc-person-gender-dropdown.component.html',
  styleUrls: ['./sc-person-gender-dropdown.component.scss']
})
export class ScPersonGenderDropdownComponent {
  public list: DropDown[];
  @Input() placeHolderLanguage: string;
  public selectedItem: DropDown;

  @Input() id: string;
  @Output() chosedItem = new EventEmitter();

  constructor(private scPersonService: ScPersonService) { }

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.scPersonService.getDropDownGender().subscribe(
      {
        next: (res) => {
          if (res)
            this.list = res.data;
          if (this.list !== null)
            this.selectedItem = this.list.find(x => x.id == this.id?.toString());
        },
        error: (err) => {
          console.log(`ScPersonGenderDropDown - getList : ${err}.`);
        }
      });
  }

  feedback() {
    if (this.selectedItem != null) {
      this.chosedItem.emit(this.selectedItem.id)
    } else {
      this.chosedItem.emit(null)
    }
  }
}